import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthLayout } from "@/components/layouts/AuthLayout";
import { I18nProvider } from "@/i18n/useTranslation";
import { UserProvider } from "@/contexts/UserContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Company from "./pages/Company";
import Employees from "./pages/Employees";
import Finances from "./pages/Finances";
import Assignments2 from "./pages/Assignments2";
import Client from "./pages/Client";
import Project from "./pages/Project";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import Transactions from "./pages/Transactions";
import Board from "./pages/Board";
import Opportunities from "./pages/Opportunities";
import Inventory from "./pages/Inventory";
import PurchaseRequest from "./pages/PurchaseRequest";
import Settings from "./pages/Settings";
import NotFound from "./components/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <UserProvider>
      <I18nProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route element={<AuthLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/company" element={<Company />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/finances" element={<Finances />} />
                <Route path="/assignments2" element={<Assignments2 />} />
                <Route path="/clients/:clientId" element={<Client />} />
                <Route path="/projects/:projectId" element={<Project />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/invoice/:invoiceId" element={<InvoiceDetail />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/board" element={<Board />} />
                <Route path="/opportunities" element={<Opportunities />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/purchase-requests/new" element={<PurchaseRequest />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </I18nProvider>
    </UserProvider>
  </QueryClientProvider>
);

export default App;
